export const headerSearchPanelStyles = {
  iconGlyph: 'h-4 w-4 shrink-0',
  panel:
    'search-panel-scroll min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-contain bg-bg-canvas md:overflow-y-hidden',
  columns:
    'grid min-h-0 min-w-0 grid-cols-1 md:h-full md:grid-cols-[minmax(14rem,0.9fr)_minmax(0,2fr)]',
  aside:
    'search-panel-scroll min-h-0 min-w-0 space-y-6 overflow-x-hidden overscroll-contain p-4 md:overflow-y-auto md:border-r md:border-border-subtle md:bg-bg-subtle/50 md:p-6',
  resultsAside:
    'min-w-0 border-b border-border-subtle bg-bg-subtle/50 p-4 lg:min-h-0 lg:overflow-x-hidden lg:overflow-y-auto lg:overscroll-contain lg:border-b-0 lg:border-r lg:p-6',
  resultsPanel:
    'search-panel-scroll min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-contain bg-bg-canvas lg:flex lg:overflow-y-hidden',
  resultsColumns:
    'min-w-0 lg:grid lg:min-h-0 lg:flex-1 lg:grid-cols-[minmax(13rem,0.65fr)_minmax(0,1fr)_minmax(0,1fr)]',
  resultsMain:
    'min-w-0 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] lg:min-h-0 lg:overflow-x-hidden lg:overflow-y-auto lg:overscroll-contain lg:p-6',
  categoryHeading: 'mb-3 hidden text-xs font-semibold text-fg-muted md:block',
  brandsSection: 'min-w-0',
  main: 'search-panel-scroll min-h-0 min-w-0 overflow-x-hidden overscroll-contain p-4 md:overflow-y-auto md:p-6',
  heading: 'mb-3 text-xs font-semibold text-fg-muted',
  sectionHeader: 'mb-3 flex items-center justify-between gap-3',
  headingTitle: 'text-xs font-semibold text-fg-muted',
  historyHeader: 'mb-2 flex items-center justify-between gap-2',
  historyHeading: 'text-xs font-semibold text-fg-muted',
  textButton:
    'rounded px-1 py-2 text-xs font-medium text-accent hover:text-accent-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
  historyRow:
    'flex items-center rounded-md hover:bg-bg-subtle has-[[aria-selected=true]]:bg-accent/10',
  historyItem:
    'flex min-h-11 min-w-0 flex-1 items-center gap-3 rounded-md px-2 text-left text-sm text-fg-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
  historyTerm: 'min-w-0 flex-1 truncate',
  historyRemove:
    'inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-fg-muted hover:text-danger focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
  chips: 'flex min-w-0 max-w-full flex-wrap gap-2',
  chip: 'inline-flex min-h-11 min-w-0 max-w-full items-center gap-2 break-words rounded-full border border-border-subtle bg-bg-canvas px-3 py-2 text-xs font-medium text-fg-primary transition-colors hover:border-accent hover:bg-accent/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
  suggestedChip:
    'inline-flex min-h-11 items-center gap-2 rounded-full bg-accent/10 px-3 py-2 text-xs font-medium text-accent transition-colors hover:bg-accent/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
  categoryGrid: 'grid grid-cols-3 gap-2 sm:grid-cols-4 md:gap-3',
  categoryTile:
    'group flex min-w-0 flex-col items-center gap-3 rounded-xl border border-transparent bg-bg-subtle p-3 text-center text-xs font-semibold text-fg-primary transition-colors hover:border-accent/30 hover:bg-accent/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
  categoryImage:
    'h-16 w-full object-contain transition-transform group-hover:scale-105 motion-reduce:transform-none md:h-20',
  categoryFallback: 'my-4 h-8 w-8 text-fg-muted',
  categoryName: 'line-clamp-2',
  categoryMatches: 'flex min-w-0 flex-wrap gap-2 md:flex-col',
  categoryMatch:
    'flex min-h-11 min-w-0 max-w-full items-center gap-2 rounded-md border border-border-subtle px-3 py-2 text-sm text-fg-primary hover:border-accent/30 hover:bg-accent/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent md:border-transparent',
  categoryMatchName: 'min-w-0 flex-1 break-words',
  count: 'ml-auto shrink-0 pl-2 text-xs tabular-nums text-fg-muted',
  empty: 'py-4 text-sm text-fg-muted',
  status:
    'flex min-h-48 flex-col items-center justify-center gap-3 text-center text-sm text-fg-muted',
  list: 'flex flex-col gap-1',
  item: 'flex min-h-20 items-center gap-3 rounded-xl border border-transparent p-2 text-left text-sm text-fg-primary transition-colors hover:border-accent/20 hover:bg-accent/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent aria-selected:border-accent/30 aria-selected:bg-accent/5 md:gap-4',
  thumb: 'h-16 w-16 shrink-0 rounded-lg border border-border-subtle bg-white object-contain p-1',
  itemBody: 'flex min-w-0 flex-1 flex-col gap-1',
  itemTitle: 'line-clamp-2 break-words font-medium leading-snug',
  itemPrices: 'flex flex-wrap items-center gap-x-2 gap-y-1',
  itemPrice: 'font-semibold tabular-nums text-fg-primary',
  salePrice: 'text-danger',
  itemOriginalPrice: 'text-xs tabular-nums text-fg-muted line-through',
  stock: 'rounded bg-success/10 px-1.5 py-0.5 text-[10px] font-medium text-success',
  noStock: 'rounded bg-bg-subtle px-1.5 py-0.5 text-[10px] font-medium text-fg-muted',
  footer:
    'mt-4 flex min-h-11 items-center justify-center gap-2 rounded-lg bg-accent/10 px-4 py-3 text-sm font-semibold text-accent transition-colors hover:bg-accent/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
  spinner: 'h-5 w-5 animate-spin text-accent motion-reduce:animate-none',
} as const;
